import { createStyles, makeStyles } from '@material-ui/core/styles'
import * as React from 'react'

import { Theme } from '../../themes/ThemeProvider'
import { Autocomplete, AutoCompleteProps } from '../base/AutoComplete'
import Colors from '../base/Color'
import Checkbox from '../controls/Checkbox'
import TextField from '../input/Input'
import Tags from '../tags'

export interface SkillSetData {
  label: string
  value: string
}

export interface SkillSetAutoCompleteProps
  extends Omit<
    AutoCompleteProps<SkillSetData, true, true, undefined>,
    'options' | 'renderInput'
  > {
  dataSkillSets: SkillSetData[]
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#F8FAFB'
    },
    chip: {
      background: '#ECECEC',
      color: '#222222',
      borderRadius: '4px'
    },
    inputRoot: {
      padding: '10px 8px'
    },
    placeholder: {
      '::placeholder': {
        color: Colors.primary[800]
      }
    },
    checkbox: {
      padding: '4px'
    }
  })
)

export const SkillSetAutoComplete: React.FC<SkillSetAutoCompleteProps> = (
  props
) => {
  const { dataSkillSets, size, ...rest } = props
  const classes = useStyles()
  return (
    <Autocomplete
      multiple
      className={classes.root}
      options={dataSkillSets}
      disableCloseOnSelect
      getOptionLabel={(option) => option.label}
      renderOption={(option, { selected }) => (
        <Checkbox
          className={classes.checkbox}
          checked={selected}
          label={option.label}
        />
      )}
      renderInput={(params) => <TextField placeholder="Search" {...params} />}
      renderTags={(values, getTagProps) =>
        values.map((item, index) => (
          <Tags
            label={item.label}
            key={item.value}
            customVariant="autocomplete"
            {...getTagProps({ index })}
          />
        ))
      }
      {...rest}
    />
  )
}
